<template>
  <v-app style="max-height: 100px">
      <v-container class=" mt-8">
    <v-alert
        border="bottom"
        colored-border
        type="warning"
        class="mx-2 mt-4"
        elevation="2"
    >
      این پروژه در حال حاضر،‌در مرحله پیش ثبت نام بیلبورد است.
    </v-alert>
      </v-container>
  </v-app>
</template>

<script>
export default {
  name: "index",
  mounted() {
    this.$modal.info('مرحله پیش ثبت نام' , 'این پروژه در حال حاضر،‌در مرحله پیش ثبت نام بیلبورد است.');
  }
}
</script>

<style scoped>

</style>